import { Box, Button, CircularProgress, Container, Grid2 as Grid, Link, Paper, Stack, Typography } from "@mui/material"
import { resetPasswordReq } from "../../redux/member-slices/auth.slice"
import { Link as NavLink, useSearchParams } from "react-router-dom"
import { resetPasswordSchema } from "../../utils/velidations"
import InputFieldB from "../../components/ui/InputFieldB"
import { useDispatch, useSelector } from "react-redux"
import ReCAPTCHA from "react-google-recaptcha"
import { useState } from "react"

function ResetPassword() {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token")
  const [helperText, setHelperText] = useState([])
  const { other } = useSelector(state => state.memberSlice)

  // Handle forgot password 
  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = new FormData(e.target)
    const formData = Object.fromEntries(form)
    formData.token = token
    const result = resetPasswordSchema.safeParse(formData)
    if (!result.success) {
      const groupedErrors = {}
      result.error.issues.forEach((issue) => {
        const key = issue.path[0]
        if (!groupedErrors[key]) {
          groupedErrors[key] = []
        }
        groupedErrors[key].push(issue.message)
      })
      setHelperText(groupedErrors)
      return
    }
    setHelperText([])
    await dispatch(resetPasswordReq(formData)).unwrap()
    e.target.reset()
  }

  return (
    <Box sx={{ py: 3 }}>
      <Container maxWidth={false} fixed>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }} mx="auto">
            <Paper
              sx={{
                p: 3,
                border: "1px solid #f0f0f0"
              }}
              component="form"
              onSubmit={handleSubmit}
            >
              <Typography
                mb={1}
                fontSize={20}
                component="h4"
                color="other.color1"
                fontWeight="600"
                textAlign="center"
              >Reset Password
              </Typography>

              <Stack spacing={3}>
                <InputFieldB
                  type="password"
                  name="password"
                  label="Password"
                  inputtype="InputFieldB"
                  helperText={helperText}
                  placeholder="Enter password"
                />
                <InputFieldB
                  type="password"
                  name="confPassword"
                  inputtype="InputFieldB"
                  helperText={helperText}
                  label="confirm password"
                  placeholder="Enter confirm password"
                />
                <Box>
                  <ReCAPTCHA sitekey={process.env.REACT_APP_CAPTCHA_KEY} />
                  {helperText?.["g-recaptcha-response"] &&
                    <Typography
                      mt={0.5}
                      fontSize="14px"
                      color="error.main"
                    >{helperText?.["g-recaptcha-response"]}
                    </Typography>
                  }
                  <Typography
                    fontSize={14}
                    color="other.color1"
                    textAlign="end"
                  >
                    <Link
                      to="/login"
                      sx={{ mb: "20px" }}
                      underline="hover"
                      component={NavLink}
                    >Login now
                    </Link>
                  </Typography>
                </Box>
                <Button
                  sx={{
                    fontSize: "18px",
                    justifyContent: "center",
                  }}
                  type="submit"
                  variant="contained"
                  endIcon={
                    other?.loadingLogin &&
                    <CircularProgress
                      size={22}
                      color="text"
                      thickness={6}
                    />
                  }
                >Submit
                </Button>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box >
  )
}

export default ResetPassword